/**
 * F-086 — Format milliseconds as human-friendly duration.
 *
 *   30000 → "0:30"        (under a minute)
 *   90000 → "1:30"        (minute:seconds)
 *   3661000 → "1:01:01"   (hour:minute:seconds)
 *
 * Always pads minutes/seconds to 2 digits except the leading unit.
 * Negative or NaN input → "0:00".
 */
export function formatDuration(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return "0:00";
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const ss = String(seconds).padStart(2, "0");
  if (hours > 0) {
    const mm = String(minutes).padStart(2, "0");
    return `${hours}:${mm}:${ss}`;
  }
  return `${minutes}:${ss}`;
}
